
import { defineComponent } from 'vue'
import {ComponentEnum} from '@/config/config-types';

import {LichenRecordField, newSpecimen} from "@/config/config-lichen"
import CategoryPicker from "@/components/picker/CategoryPicker.vue"
import StringPicker from "@/components/picker/StringPicker.vue"
import Button from "primevue/button";
import InfoButton from "@/components/legend/InfoButton.vue";

export default defineComponent({
  name: "SpecimenPickerItem",
  components: {StringPicker, CategoryPicker, Button, InfoButton},
  data() {
    return {
      ComponentEnum,
      specimen: newSpecimen() as LichenRecordField[]
    }
  },
  props: {
    value: {type: [] as any[], required: true},
    idx: {type: Number, required: true}
  },
  methods: {
    select(value: any) {
      this.$emit('select', {value: value.value, key: value.key, idx: this.idx})
    }
  },
  beforeMount() {

    // @ts-ignore
    this.specimen[0].value = this.value["specimenType"]
    // @ts-ignore
    this.specimen[1].value = this.value["herbarium"]
    // @ts-ignore
    this.specimen[2].value = this.value["specimenLabel"]
    // @ts-ignore
    this.specimen[3].value = this.value["specimenRecordId"]

  }
})
